module.exports = __webpack_public_path__ + "img/NEOCONF2020.7b29773f.png";